import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';
import { SkeletonCard } from '../common';

export function ThirdBlock() {
  return (
    <SkeletonCard className="h-[212px] rounded-[16px] gap-[16px]">
      <SkeletonBlock className="h-[16px] w-[clamp(119px,30%,240px)]" variant="sunked" />
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex items-center gap-[8px]">
          <SkeletonBlock className="w-[21px] h-[16px]" variant="sunked" />
          <SkeletonBlock className="flex-1 min-w-0 h-[16px]" variant="sunked" />
          <SkeletonBlock className="w-[21px] h-[16px]" variant="sunked" />
        </div>
      ))}
    </SkeletonCard>
  );
}
